var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    fill: "#7FF6B6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855_3435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 23.0001C12.7346 23.0001 12.4803 22.8947 12.2928 22.7071L9.29281 19.7071C9.10199 19.5229 8.99215 19.2705 8.98746 19.0053C8.98277 18.7401 9.08362 18.4839 9.26781 18.2931C9.452 18.1023 9.70446 17.9925 9.96963 17.9878C10.2348 17.9831 10.491 18.0839 10.6818 18.2681L10.7068 18.2931L12.8788 20.4661L20.1908 10.4121C20.3468 10.1976 20.5816 10.0537 20.8435 10.0123C21.1055 9.97084 21.3733 10.0352 21.5878 10.1911C21.8024 10.3471 21.9462 10.5819 21.9876 10.8438C22.0291 11.1058 21.9648 11.3736 21.8088 11.5881L13.8088 22.5881C13.7241 22.7056 13.6148 22.8034 13.4886 22.8745C13.3624 22.9456 13.2222 22.9885 13.0778 23.0001H12.9998Z",
    fill: "#5F1CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13H22.5C22.2239 13 22 13.2239 22 13.5V14.5C22 14.7761 22.2239 15 22.5 15H24.5C24.7761 15 25 14.7761 25 14.5V13.5C25 13.2239 24.7761 13 24.5 13Z",
    fill: "#5F1CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17H19.5C19.2239 17 19 17.2239 19 17.5V18.5C19 18.7761 19.2239 19 19.5 19H24.5C24.7761 19 25 18.7761 25 18.5V17.5C25 17.2239 24.7761 17 24.5 17Z",
    fill: "#5F1CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21H16.5C16.2239 21 16 21.2239 16 21.5V22.5C16 22.7761 16.2239 23 16.5 23H24.5C24.7761 23 25 22.7761 25 22.5V21.5C25 21.2239 24.7761 21 24.5 21Z",
    fill: "#5F1CCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_3435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommision);
export default __webpack_public_path__ + "static/media/commision.5f056ada556f6bd27516585aefdc3551.svg";
export { ForwardRef as ReactComponent };